import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../Pages/CreateEditPage.css";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import FileUploadComponent from "../Components/FileUploadComponent.tsx";
import { Committenti, Referenti } from "../lib/interface.ts";
import ModalFormReferenti from "./ModalFormReferenti.tsx";
import { useDispatch, useSelector } from "react-redux";
import { allGet, allPost, allPut } from "../Redux/Actions.tsx";
import { urlcommittenti, urlreferenti } from "../lib/api.ts";
import { AppDispatch, RootState } from "../Redux/Store/index.ts";
import { useAlert } from "./Alert.tsx";
import DeleteModal from "./DeleteModal.tsx";
import { ListBox } from "primereact/listbox";

interface FormClientiProps {
  action: "crea" | "modifica";
  type: any;
  id?: any;
}

const FormClienti: React.FC<FormClientiProps> = ({ action, type, id }) => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);

  const showAlert = useAlert();
  const [isEditing, setIsEditing] = useState<boolean>(!id);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Aggiorniamo lo stato errors per includere codiceFiscale
  const [errors, setErrors] = useState({
    ragioneSociale: false,
  });

  const [committente, setCommittente] = useState<Committenti>({
    id: "",
    protocollo: "",
    ragioneSociale: "",
    partitaIva: "",
    sdi: "",
    codiceFiscale: "",
    telefono: "",
    email: "",
    pec: "",
    sitoWeb: "",
    indirizzo: "",
    cap: "",
    citta: "",
    tipologia: "",
    note: "",
    referenti: [],
    contrattiQuadro: [],
  });

  const tipologiaOptions = [
    { label: "Privato", value: "PRIVATO" },
    { label: "Persona Fisica Titolare di Partita IVA", value: "PFTPI" },
    { label: "Soggetto Diverso da Persona Fisica", value: "SDPF" },
  ];

  // Funzione di validazione dei campi obbligatori
  const validateFields = () => {
    const newErrors = {
      ragioneSociale: !committente.ragioneSociale.trim(),
    };
    setErrors(newErrors);

    // true se TUTTI i campi sono compilati
    return !Object.values(newErrors).some((error) => error);
  };

  // Se in modifica, carica i dati del cliente
  useEffect(() => {
    if (action === "modifica" && id) {
      const url = `${urlcommittenti}/${id}`;
      dispatch(allGet(url, token)).then((singoloCommittente) => {
        if (singoloCommittente) {
          setCommittente(singoloCommittente);
        } else {
          console.error("Errore nel caricamento del committente");
        }
      });
    }
  }, [action, id, dispatch, token]);

  // Gestione generica dei campi testuali
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCommittente((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddReferente = (nuovoReferente: Referenti) => {
    setCommittente((prev) => ({
      ...prev,
      referenti: [...prev.referenti, nuovoReferente],
    }));
  };

  const updateReferente = (updatedReferente: Referenti) => {
    setCommittente((prevCommittente) => ({
      ...prevCommittente,
      referenti: prevCommittente.referenti.map((referente) =>
        referente.id === updatedReferente.id ? updatedReferente : referente
      ),
    }));
  };

  const setArrayReferenti = (arrayRef: Referenti[]) => {
    setCommittente((prevCommittente) => ({
      ...prevCommittente,
      referenti: arrayRef,
    }));
  };

  const handleSelectChange = (e: { value: string }) => {
    setCommittente((prev) => ({
      ...prev,
      tipologia: e.value,
    }));
    setErrors((prev) => ({ ...prev, tipologia: false }));
  };

  // Chiudi la pagina
  const handleClose = () => {
    navigate("/committenti");
  };

  // Chiudi modale di eliminazione
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  // Salva (crea o modifica)
  const handleSubmit = () => {
    if (!validateFields()) {
      // if (committente.sdi.trim().length > 7) {
      //   showAlert("danger", "Errore", "SDI deve avere max 7 caratteri.", "bottom-end", 3000);
      // } else {
      showAlert(
        "danger",
        "Errore",
        "Compila i campi obbligatori (Ragione Sociale, P.IVA, SDI (max 7 car), Email, Tipologia, Codice Fiscale).",
        "bottom-end",
        3000
      );
      // }
      return; // Non chiudere form
    }

    if (action === "crea") {
      dispatch(allPost(urlcommittenti, token, committente, showAlert)).then((idCommittente) => {
        if (idCommittente) {
          showAlert("success", "Creato", "Cliente creato con successo.", "bottom-end", 3000);
          // Se ci sono referenti in locale, li salviamo
          committente.referenti.forEach((referente) => {
            const updatedReferente = {
              ...referente,
              committenteId: idCommittente,
            };
            dispatch(allPost(urlreferenti, token, updatedReferente, showAlert));
          });
          handleClose();
        } else {
          console.error("Creazione del committente fallita");
        }
      });
    } else if (action === "modifica" && id) {
      const url = `${urlcommittenti}/${id}`;
      dispatch(allPut(url, token, committente, showAlert)).then((updatedCommittente) => {
        if (updatedCommittente) {
          showAlert("success", "Salvato", "Cliente modificato con successo.", "bottom-end", 3000);
          setIsEditing(false);
          handleClose();
        } else {
          console.error("Modifica del committente fallita");
        }
      });
    }
  };

  return (
    <div className="home-container">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center mb-3">
        <h2 className="titolo-header-Crea-Edit">
          Cliente/
          <b>{action === "crea" ? "Nuovo Cliente" : committente.ragioneSociale}</b>
        </h2>

        <div className="d-flex">
          {isEditing ? (
            <Button className="ms-2 button d-flex px-3" onClick={handleSubmit}>
              <i className="pi pi-save me-2"></i>
              <p className="p-0 m-0">Salva</p>
            </Button>
          ) : (
            <Button className="ms-2 button d-flex px-3" onClick={handleEdit}>
              <i className="pi pi-pencil me-2"></i>
              <p className="p-0 m-0">Modifica</p>
            </Button>
          )}
          {action === "modifica" && (
            <Button onClick={() => setIsDeleteModalOpen(true)} className="ms-2 button d-flex px-3">
              <i className="pi pi-trash me-2"></i>
              <p className="p-0 m-0">Elimina</p>
            </Button>
          )}
          <Button className="ms-2 button d-flex px-3" onClick={handleClose}>
            <i className="pi pi-times me-2"></i>
            <p className="p-0 m-0">Chiudi</p>
          </Button>
        </div>
      </div>
      <Row className="g-3">
        <Col xs={12} className="px-0">
          <div className="create-edit-top">
            <Row className="row-form">
              <Col lg={4} className="colonna-form">
                {/* Protocollo (solo in modifica) */}
                {action === "modifica" && (
                  <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                    <Form.Label>Protocollo </Form.Label>
                    <InputText
                      className="w-50 input-crea-edit"
                      name="ragioneSociale"
                      value={committente.protocollo}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      placeholder=""
                      disabled
                    />
                  </Form.Group>
                )}

                {/* Ragione Sociale (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>
                    Ragione sociale <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="ragioneSociale"
                    value={committente.ragioneSociale}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, ragioneSociale: false }));
                    }}
                    placeholder="Inserisci ragione sociale"
                    disabled={!isEditing}
                    style={errors.ragioneSociale ? { border: "1px solid red" } : {}}
                  />
                </Form.Group>

                {/* Partita IVA (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>
                    P.IVA <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="partitaIva"
                    value={committente.partitaIva}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, partitaIva: false }));
                    }}
                    placeholder="Inserisci P.IVA"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Codice Fiscale (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>
                    C. fiscale <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="codiceFiscale"
                    value={committente.codiceFiscale}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, codiceFiscale: false }));
                    }}
                    placeholder="Inserisci codice fiscale"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* SDI (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Sdi</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="sdi"
                    value={committente.sdi}
                    onChange={(e) => {
                      handleChange(e);
                      // setErrors((prev) => ({ ...prev, sdi: false }));
                    }}
                    placeholder="Inserisci codice SDI"
                    disabled={!isEditing}
                    // style={errors.sdi ? { border: "1px solid red" } : {}}
                  />
                </Form.Group>

                {/* Telefono */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Telefono</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="telefono"
                    value={committente.telefono}
                    onChange={handleChange}
                    placeholder="Inserisci telefono"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Email (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>
                    Email <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="email"
                    value={committente.email}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, email: false }));
                    }}
                    placeholder="Inserisci email"
                    disabled={!isEditing}
                  />
                </Form.Group>
              </Col>

              <Col lg={4} className="colonna-centrale colonna-form">
                {/* Tipologia (obbligatorio) */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>
                    Tipologia <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Dropdown
                    className="w-50 input-crea-edit p-0"
                    name="tipologia"
                    value={committente.tipologia}
                    options={tipologiaOptions.filter((option) =>
                      option.label.toLowerCase().includes(searchText.toLowerCase())
                    )}
                    onChange={handleSelectChange}
                    onInput={(e) => {
                      const inputValue = (e.target as HTMLInputElement).value;
                      setSearchText(inputValue);
                    }}
                    placeholder="Seleziona tipologia"
                    disabled={!isEditing}
                    editable
                  />
                </Form.Group>

                {/* PEC */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>PEC</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="pec"
                    value={committente.pec}
                    onChange={handleChange}
                    placeholder="Inserisci PEC"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Sito Web */}
                <Form.Group className="mb-2 px-4  responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Sito web</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="sitoWeb"
                    value={committente.sitoWeb}
                    onChange={handleChange}
                    placeholder="Inserisci sito web"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Indirizzo */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Indirizzo</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="indirizzo"
                    value={committente.indirizzo}
                    onChange={handleChange}
                    placeholder="Inserisci indirizzo"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Città */}
                <Form.Group className="mb-2 px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Città</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="citta"
                    value={committente.citta}
                    onChange={handleChange}
                    placeholder="Inserisci città"
                    disabled={!isEditing}
                  />
                </Form.Group>

                {/* Cap */}
                <Form.Group className="px-4 responsive-px d-flex justify-content-between align-items-center">
                  <Form.Label>Cap</Form.Label>
                  <InputText
                    className="w-50 input-crea-edit"
                    name="cap"
                    value={committente.cap}
                    onChange={handleChange}
                    placeholder="Inserisci CAP"
                    disabled={!isEditing}
                  />
                </Form.Group>
              </Col>

              {/* Contratti associati */}
              <Col lg={4} className="colonna-form">
                <h6 className="text-center">Contratti</h6>
                <Form.Group>
                  <ListBox
                    value={null}
                    options={committente.contrattiQuadro.map((contratto) => ({
                      label: contratto.codice,
                      value: contratto.id,
                    }))}
                    className="w-100 list-box"
                    emptyMessage="Nessun contratto associato al Cliente"
                    itemTemplate={(option) => (
                      <div className="d-flex align-items-center justify-content-between">
                        <span>{option.label}</span>
                        <i
                          className="pi pi-eye"
                          style={{ cursor: "pointer", color: "#007bff" }}
                          onClick={() => navigate("/modifica/contratti/" + option.value)}
                          title="Visualizza contratto"
                        ></i>
                      </div>
                    )}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Col>

        {/* File Upload Section */}
        <Col lg={5} className="ps-0">
          <Container className="create-edit-under">
            {committente.ragioneSociale && action === "modifica" ? (
              <FileUploadComponent folderType="committenti" folderKey={committente.ragioneSociale} />
            ) : (
              <>
                <h5 className="text-start m-0">File</h5>
                <br />
                <p>Per caricare un file, devi prima aver creato il cliente</p>
              </>
            )}
          </Container>
        </Col>

        {/* Referenti Section */}
        <Col lg={7} className="pe-0">
          <div className="create-edit-under div-flex-bet">
            <ModalFormReferenti
              arrayReferenti={committente.referenti}
              onAddReferente={handleAddReferente}
              updateReferenti={updateReferente}
              setArrayReferenti={setArrayReferenti}
              action={action}
              idCommittente={id || ""}
            />
          </div>
        </Col>
      </Row>

      {/* Modale di eliminazione */}
      <DeleteModal
        type="committente"
        idObj={committente.id}
        matchIdentifier={committente.ragioneSociale}
        show={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onDeleteSuccess={() => {
          handleClose();
        }}
      />
    </div>
  );
};

export default FormClienti;
